export default "__VITE_ASSET__BGL6ud_U__"